import { useMemo } from 'react';

import { Contract } from 'ethers';

import useFiboChainRpc from '@/store/builtInRpc/useFiboChainRpc';
import LP_ABI from '@/store/wallet/tools/contract/abi/lp.json';

/**
 * useLpContract Hook
 * ---------------------
 * 根据传入的 token 地址，结合当前钱包连接状态（signer 或 provider），
 * 创建并返回一个 Lp 合约实例。
 *
 * 使用场景：
 * - 适用于页面或组件中动态使用不同的 Lp Token 合约；
 * - 每次调用都生成一个独立合约实例，不依赖全局状态管理；
 * - 不进行全局缓存（如 Zustand），适合轻量、解耦、可组合的使用方式。
 *
 * @param tokenAddress Lp 合约地址（可选）
 * @returns Lp 合约实例或 null（未连接或地址无效时）
 */
export default function useLpContract(tokenAddress?: string) {
    const { providerEvmReadOnly } = useFiboChainRpc();

    return useMemo(() => {
        // 无地址或无有效 signer/provider 时返回 null，避免错误调用
        if (!tokenAddress || !providerEvmReadOnly) return null;

        // 返回合约实例（由 signer 控制写操作，provider 控制读操作）
        return new Contract(tokenAddress, LP_ABI, providerEvmReadOnly);
    }, [tokenAddress, providerEvmReadOnly]);
}